import gql from 'graphql-tag'

export const eligibilityTypeEnumValues = gql`
  query eligibilityTypeEnumValues {
    __type(name: "EligibilityTypeEnum") {
      enumValues {
        name
      }
    }
  }
`
